import Base from './base';

export default class AccessToken extends Base {
  resource = '/access_token';
}
